import { render, staticRenderFns } from "./IconCollection.vue?vue&type=template&id=06b63f46"
import script from "./IconCollection.vue?vue&type=script&lang=js"
export * from "./IconCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports